import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';

// Cylindo owns the AR panel inside its shadow root, so watch for <cylindo-ar>. Our
// floating controls have to hide while it's up or they cover its close button (CON-8444).
const useCylindoARActive = viewerId => {
  const $ = _c(12);
  const [isARActive, setIsARActive] = useState(false);
  const observerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = root => () => {
      const next = !!root.querySelector("cylindo-ar");
      setIsARActive(prev => prev === next ? prev : next);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const makeSync = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = root_0 => {
      observerRef.current?.disconnect();
      const sync = makeSync(root_0);
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(root_0, {
        childList: true,
        subtree: true
      });
      observerRef.current = observer;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const observe = t1;
  let t2;
  let t3;
  if ($[2] !== viewerId) {
    t2 = () => {
      const viewer = document.getElementById(viewerId);
      const root_1 = viewer?.shadowRoot;
      if (!root_1) {
        return;
      }
      observe(root_1);
      return () => {
        observerRef.current?.disconnect();
        observerRef.current = null;
      };
    };
    t3 = [viewerId, observe];
    $[2] = viewerId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== viewerId) {
    t4 = () => {
      if (observerRef.current) {
        return;
      }
      const root_2 = document.getElementById(viewerId)?.shadowRoot;
      if (!root_2) {
        return;
      }
      observe(root_2);
    };
    $[5] = viewerId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const rearm = t4;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
    t6 = [];
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== isARActive || $[10] !== rearm) {
    t7 = {
      isARActive,
      rearm
    };
    $[9] = isARActive;
    $[10] = rearm;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default useCylindoARActive;